import NBXAccounts from 'services/accounts.service';
import { buildTransform } from './transformTaxRecords';

const typeMap = {
  CARD_KICKBACK: 'Card Cashback'
};

const transform = buildTransform(typeMap);

export const fetchKickbackTaxRecords = year =>
  NBXAccounts.getKickbackTaxReports(year).then(records => records.map(transform));
